module.exports = __webpack_public_path__ + "assets/c99c666e91174a1567352680de917e84.mp3";